import ReactTooltip from 'react-tooltip'

import HotelLocalTime from '../../../../components/ReusableComponents/HotelLocalTime/index'
import styles from './LocaleCard.module.scss'

const LocaleCard = ({ ianaTimeZoneId, utcOffSet, currency, tzTimeZoneName }) => {
  return (
    <div className={styles.localeCard} data-tip={tzTimeZoneName}>
      <ReactTooltip />
      <div className={styles.timeInfo}>
        <span className={styles.time}>
          <HotelLocalTime timeZoneId={ianaTimeZoneId} />
        </span>
      </div>
      <div className={styles.currency}>
        UTC {utcOffSet} / {currency}
      </div>
    </div>
  )
}

export default LocaleCard
